import { HeaderSerasaModule } from './header-serasa/header-serasa.module';
import { SubHeaderNormalModule } from './sub-header-normal/sub-header-normal.module';
import { CardModule } from './card/card.module';
import { SubHeaderGradientModule } from './sub-header-gradient/sub-header-gradient.module';
import { FooterModule } from './footer/footer.module';
import { MenuModule } from './menu/menu.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderModule } from './header/header.module';
import { ProfileModule } from './profile/profile.module';
import { ModalModule } from './modal/modal.module';
import { LoadingAreaModule } from './loading-area/loading-area.module';
import { IconSvgModule } from './icon-svg/icon-svg.module';
import { MessageBoxModule } from './message-box/message-box.module';
import { ButtonModule } from './button/button.module';
import { ModalBoxModule } from './modal-box/modal-box.module';
import { LoadingModule } from './loading/loading.module';
import { AlertMessageModule } from './alert-message/alert-message.module';
import { MessageErrorModule } from './message-error/message-error.module';
import { RadioButtonModule } from './radio-button/radio-button.module';
import { ImageCropperModule } from './image-cropper/image-cropper.module';
import { FormErrorsModule } from './form-errors/form-errors.module';
import { TrackingModule } from './tracking/tracking.module';
import { ButtonCertificateModule } from './button-certificate/button-certificate.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
    imports: [
        CommonModule,
        HeaderModule,
        MenuModule,
        ProfileModule,
        SubHeaderGradientModule,
        CardModule,
        SubHeaderNormalModule,
        ModalModule,
        HeaderSerasaModule,
        LoadingModule,
        LoadingAreaModule,
        IconSvgModule,
        MessageBoxModule,
        ButtonModule,
        ModalBoxModule,
        AlertMessageModule,
        MessageErrorModule,
        RadioButtonModule,
        ImageCropperModule,
        FormErrorsModule,
        TrackingModule,
        ButtonCertificateModule,
        BrowserAnimationsModule
        
    ],
    exports: [
        HeaderModule,
        MenuModule,
        ProfileModule,
        FooterModule,
        SubHeaderGradientModule,
        CardModule,
        SubHeaderNormalModule,
        ModalModule,
        HeaderSerasaModule,
        LoadingModule,
        LoadingAreaModule,
        IconSvgModule,
        MessageBoxModule,
        ButtonModule,
        ModalBoxModule,
        AlertMessageModule,
        MessageErrorModule,
        RadioButtonModule,
        ImageCropperModule,
        FormErrorsModule,
        TrackingModule,
        ButtonCertificateModule
    ],
    declarations: [],
    bootstrap: [
        CommonModule,
        HeaderModule,
        MenuModule,
        ProfileModule,
        SubHeaderGradientModule,
        CardModule,
        SubHeaderNormalModule,
        ModalModule,
        HeaderSerasaModule,
        LoadingModule,
        LoadingAreaModule,
        IconSvgModule,
        MessageBoxModule,
        ButtonModule,
        ModalBoxModule,
        AlertMessageModule,
        MessageErrorModule,
        RadioButtonModule,
        ImageCropperModule,
        FormErrorsModule,
        TrackingModule,
        ButtonCertificateModule,
    ]
})
export class ProofLifeComponentsModule {}
